import React, {useEffect, useState} from 'react';
import s from "./Wallet.module.sass";

export const Button = ({status}) => {
    const [result, setResult] = useState(null);
    const [ownStatus, setOwnStatus] = useState(status);

    useEffect(() => {
        // Обновляем ownStatus при изменении входного пропса status
        setOwnStatus(status);
    }, [status]);

    useEffect(() => {
        // Меняем контент кнопки в зависимости от статуса
        if (ownStatus === 'success') {
            setResult(<span onClick={() => setOwnStatus('error')} className={s.statusSuccess}>Success</span>);
        } else if (ownStatus === 'error') {
            setResult(<span onClick={() => setOwnStatus('inprocess')} className={s.error}>Success</span>);
        } else if (ownStatus === 'inprocess') {
            setResult(<span onClick={() => setOwnStatus('pending')} className={s.inprocess}>In Process</span>);
        } else if (ownStatus === 'pending') {
            setResult(<span onClick={() => setOwnStatus('fixed')} className={s.pending}>Pending</span>);
        } else if (ownStatus === 'fixed') {
            setResult(<span onClick={() => setOwnStatus('success')} className={s.fixed}>Fixed</span>);
        }else if (ownStatus === 'fixed') {
            setResult(<span onClick={() => setOwnStatus('success')} className={s.fixed}>Fixed</span>);
        }
    }, [ownStatus]); // Зависимость от ownStatus, чтобы перерисовывать кнопку при изменении статуса

    return (
        <>
            {result}
        </>
    );
};
